
import { Container } from 'react-bootstrap';
import { Row } from 'antd';
import { Col } from 'antd';
import { Link } from 'react-router-dom';
import { AppstoreAddOutlined } from '@ant-design/icons';
import { Pagination } from 'antd';
import { PRODUCT_DELETE_SUCCESS } from '../../../app/eventBus/productEvents/productEvents';
import EventBus from '../../../app/eventBus/EventBus';
import { useEffect } from 'react';
import Products from '../../../components/monaliza/product/Products';
import { useSelector, useDispatch } from 'react-redux';
import { changeFilterOptionsAsync, getProductCountAsync, getProductsAsync, selectProductCount, selectProductFilterOptions, selectProducts } from '../../../app/store/reducers/product/productReducer';



const MyProductList = () => {
    const products = useSelector(selectProducts)
    const count = useSelector(selectProductCount)
    const filters = useSelector(selectProductFilterOptions)
    const dispatch = useDispatch()
  
    const onShowSizeChange = (current, pageSize) => dispatch(changeFilterOptionsAsync({...filters, limit: pageSize, page: current}))
  
    const loadProducts = () => {
      dispatch(getProductsAsync({...filters}))
      dispatch(getProductCountAsync({...filters}))
    }

    

    useEffect(() => {
      loadProducts()
  
      const deleteHandler = EventBus.on(PRODUCT_DELETE_SUCCESS, () => {
        loadProducts()
      })
  
  
      return () => {
        EventBus.remove(PRODUCT_DELETE_SUCCESS, deleteHandler)
      }
    },[filters])


    return (
    <>
        <Container>
        <Row className="my-5 d-flex justify-content-between">
          <h1 className="text-center">My Product list</h1>
          <Col className="d-flex align-items-center justify-content-between">
              <Link to="/product/register">
                <AppstoreAddOutlined style={{fontSize: "25px", color: "blue", border: "2px blue solid", borderRadius: "50%", padding: "3px"}} />
              </Link>
          </Col>
        </Row>

        <Products random={false} products={products}/>
        <Col className="my-3 d-flex justify-content-center align-items-center">
        <Pagination 
            defaultCurrent={filters?.page} 
            total={count}
            pageSize={filters?.limit}
            onShowSizeChange={onShowSizeChange}
        />
        </Col>
      </Container>
    </>
  )
}

export default MyProductList